import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BusinessModel} from '../../../../core-logic/models/business/business-model';
import {BusinessGatewayHttp} from '../../../../adapters/real/api-services/gateways/business-gateway-http';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {getFileReader} from '../../../../common/functions/utilities-functions';
import {BusinessLogoManagerService} from '../../../../common/services/business-logo-manager.service';

@Component({
  selector: 'app-small-loyalty-card',
  templateUrl: './small-loyalty-card.component.html',
  styleUrls: ['./small-loyalty-card.component.scss'],
})
export class SmallLoyaltyCardComponent implements OnInit, OnChanges {
  @Input() business: BusinessModel;
  private readonly defaultLogo = 'assets/icons/default-business-logo.png';
  // eslint-disable-next-line @typescript-eslint/member-ordering
  logo: any = this.defaultLogo;
  constructor(private businessGatewayHttp: BusinessGatewayHttp,
              private changeDetector: ChangeDetectorRef,
              private businessLogoManagerService: BusinessLogoManagerService,
  ) { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.business) {
      this.business = changes.business.currentValue as BusinessModel;
      if (this.business.customizer && this.business.customizer.logo) {
        const businessStoredLogo: string = this.businessLogoManagerService.getLogoById(this.business.customizer.logo);
        if (businessStoredLogo) {
          this.logo = businessStoredLogo;
        } else {
          this.businessGatewayHttp.getBusinessLogoById(this.business.customizer.logo)
            .pipe(catchError(err => {
              this.logo = this.defaultLogo;
              return throwError(err);
            }))
            .subscribe(logoBlob => {
              this.imageBlobToDataURIAndAddItToStorage(this.business.customizer.logo, logoBlob, this.business._id);
            });
        }
      } else {
        this.logo = this.defaultLogo;
      }
    }
  }

  private imageBlobToDataURIAndAddItToStorage(logoId: string, imageBlob: Blob, businessId?: string) {
    const reader = getFileReader();
    reader.onloadend = () => {
      this.logo = reader.result as string;
      this.businessLogoManagerService.addBusinessLogo({logo_id: logoId, data: this.logo, business_id: businessId});
      this.changeDetector.detectChanges();
    };
    reader.readAsDataURL(imageBlob);
  }

}
